<div class="keuze-stap">
	<h3>{{ titel() }}</h3>
	<div class="instelling-list">
		@for (instelling of instellingen(); track instelling.id) {
			<div
				class="instelling-row"
				[class.instelling-row--selected]="isSelected(instelling)"
				[class.instelling-row--disabled]="isDisabled(instelling)"
				(click)="onToggle(instelling)"
			>
				<app-checkbox [value]="isSelected(instelling)" [enabled]="!isDisabled(instelling)"></app-checkbox>
				<span class="instelling-naam">{{ instelling.naam }}</span>
				<app-instelling-labels [instelling]="instelling" [toonBestuur]="false" [toonVSO]="false"></app-instelling-labels>
			</div>
		}
	</div>
</div>

